import { render, staticRenderFns } from "./ReportViewVencimientoContratoJugadores.vue?vue&type=template&id=b8f246fa&scoped=true&"
import script from "./ReportViewVencimientoContratoJugadores.vue?vue&type=script&lang=js&"
export * from "./ReportViewVencimientoContratoJugadores.vue?vue&type=script&lang=js&"
import style0 from "./ReportViewVencimientoContratoJugadores.vue?vue&type=style&index=0&id=b8f246fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f246fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTooltip,
})
